<template>
  <div class="page flex-col">
    <AppHeader />

    <div class="ps-banner">
      <span class="ps-banner-zh">{{ isEnglish ? 'Project Site' : '工程现场' }}</span>
      <span v-if="isEnglish" class="ps-banner-en">PROJECT SITE</span>
    </div>

    <div class="ps-container">
      <div class="header-row flex-row justify-between align-end">
        <div class="title-group flex-row align-end">
          <span class="title-zh">{{ isEnglish ? 'Project Site' : '工程现场' }}</span>
          <span v-if="isEnglish" class="title-en">PROJECT SITE</span>
        </div>
        <div class="breadcrumb flex-row align-center">
          <router-link :to="homeLink" class="crumb-item">{{ isEnglish ? 'Home' : '首页' }}</router-link>
          <span class="crumb-sep">&gt;</span>
          <span class="crumb-active">{{ isEnglish ? 'Project Site' : '工程现场' }}</span>
        </div>
      </div>

      <div class="blue-divider"></div>

      <div class="gallery">
        <figure v-for="(item, index) in galleryImages" :key="index" class="gallery-item">
          <img
            class="gallery-img"
            :src="item.src"
            :alt="imageLabel(item)"
            loading="lazy"
          />
          <figcaption v-if="isEnglish" class="gallery-caption">{{ item.labelEn }}</figcaption>
        </figure>
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import { PROJECT_SITE_IMAGES } from '@/data/projectSite';
import { isEnglishRoute, siteHomeLink } from '@/utils/lang';

export default {
  name: 'ProjectSite',
  computed: {
    isEnglish() {
      return isEnglishRoute(this.$route);
    },
    homeLink() {
      return siteHomeLink(this.$route);
    },
    galleryImages() {
      return PROJECT_SITE_IMAGES;
    }
  },
  methods: {
    imageLabel(item) {
      if (!item) return '';
      return this.isEnglish ? item.labelEn : item.altZh;
    }
  }
};
</script>

<style scoped>
.page {
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
}

.ps-banner {
  width: 100%;
  height: 460px;
  margin: 0;
  position: relative;
  box-sizing: border-box;
  background: url(../lanhu_5xinwenliebiao/assets/img/FigmaDDSSlicePNG526d0ecf84407977682ce1a8a53aebba.jpg)
    center center / cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ps-banner-zh {
  margin: 0;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  color: #ffffff;
  font-size: 40px;
  font-family: 'PingFang SC-Heavy', 'PingFang SC', sans-serif;
  font-weight: 900;
  line-height: 1;
}

.ps-banner-en {
  margin: 12px 0 0;
  color: rgba(255, 255, 255, 0.5);
  font-size: 24px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  line-height: 1;
}

.ps-container {
  width: 1550px;
  max-width: 92%;
  margin: 50px auto 80px;
  box-sizing: border-box;
}

.header-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}

.title-group {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 12px;
}

.title-zh {
  font-size: 28px;
  font-weight: 900;
  color: #1e40af;
  line-height: 1;
  font-family: 'PingFang SC-Heavy', 'PingFang SC', sans-serif;
}

.title-en {
  font-size: 22px;
  font-weight: 400;
  color: #a0b2d6;
  line-height: 1;
}

.breadcrumb {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #4b4b4b;
}

.crumb-item {
  color: #4b4b4b;
  text-decoration: none;
  transition: color 0.2s ease;
}

.crumb-item:hover {
  color: #1e40af;
}

.crumb-sep {
  color: #a3a3a3;
  user-select: none;
}

.crumb-active {
  color: #1e40af;
  font-weight: 600;
}

.blue-divider {
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #1e40af 0%, #3b82f6 100%);
  margin: 24px 0 40px;
}

.gallery {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 32px;
}

.gallery-item {
  margin: 0;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  background: #f8fafc;
}

.gallery-img {
  display: block;
  width: 100%;
  height: auto;
  vertical-align: middle;
}

.gallery-caption {
  margin: 0;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  text-align: center;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
}

@media (max-width: 900px) {
  .gallery {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .ps-banner {
    height: 280px;
  }

  .ps-banner-zh {
    font-size: 28px;
  }

  .ps-banner-en {
    font-size: 18px;
  }
}
</style>
